export default "__VITE_ASSET__iSpcH1Xg__"